export class SwitcheryController {
  constructor(AppService, $element, $scope) {
    'ngInject';

    this.AppService = AppService;
    this.$element = $element;
    this.$scope = $scope; 
  }

  $onInit() {
    this.input = this.$element.find('input');
    this.id = this.setName;
    this.input.click((event) => {
      this.onClick(this.input.prop('checked'));
    });
  }

  onClick(value) {
    this.onSwitch({state: value});
  }
}

export default SwitcheryController;


// WEBPACK FOOTER //
// ./client/app/shared/ui/switchery/switchery.controller.js